module.exports = __webpack_public_path__ + "img/mobile/Background-freespins/backgroundfs_portraitv2@3x.jpg?0.0.53";